import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { logged_in as loggedIn } from 'state';

import Route from './route';

const UnauthenticatedRoute = ({ children, ...rest }) => (
  <Route {...rest}>
    {loggedIn() ? <Redirect to="/account" /> : children}
  </Route>
);

UnauthenticatedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnauthenticatedRoute;
